/** Escape a CSV cell (RFC-style quotes). */
function esc(v) {
  const s = v == null ? "" : String(v);
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

/**
 * Download rows as a CSV file.
 * @param {string} filename
 * @param {{ label: string, value: (row: any) => any }[]} columns
 * @param {any[]} rows
 */
export function downloadCsv(filename, columns, rows) {
  const lines = [
    columns.map((c) => esc(c.label)).join(","),
    ...(rows || []).map((r) => columns.map((c) => esc(c.value(r))).join(",")),
  ];
  const blob = new Blob(["\uFEFF" + lines.join("\n")], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
